import { useEffect, useState } from 'react';
import { breakpoints } from '@carbon/layout';

// SE A TELA JÁ CHEGOU A UM PONTO DO GRID DO CARBON (sm, md, lg, xlg, max). Para o que muda de
// conteúdo, e não só de aparência, numa largura: abaixo do `md`, o primário da barra da tabela usa
// o rótulo curto; a Agenda só mostra o ContentSwitcher das vistas quando ele cabe na linha.

type Ponto = keyof typeof breakpoints;

const consultaDo = (ponto: Ponto) => `(min-width: ${breakpoints[ponto].width})`;
const agora = (consulta: string) => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(consulta).matches : true);

export const useDoPonto = (ponto: Ponto) => {
  const consulta = consultaDo(ponto);
  const [chegou, setChegou] = useState(() => agora(consulta));
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia(consulta);
    const mudou = () => setChegou(mq.matches);
    mudou();
    mq.addEventListener?.('change', mudou);
    return () => mq.removeEventListener?.('change', mudou);
  }, [consulta]);
  return chegou;
};

/** Do `md` (42rem) para cima. */
export const useDoMd = () => useDoPonto('md');
